import React from 'react'

const Sixty_four = () => {
    return (
        <div className='container'>
            <h1>Arrange the string in Dictionary order larger</h1>
            <div className='containers'>
            To solve this program, a two-dimensional string named str is created. The string can hold a maximum of 5 strings and each string can have a maximum of 50 characters (including the null character)
            </div>
            <div className='containers'>
           <code className='library'> include</code> &lt;stdio.h&gt; <br />
           <code className='library'> #include</code> &lt;string.h&gt;<br />
           <br />
           <code className='keywords'> int </code>main() &#123;<br />
           <code className='keywords'> char</code> str[5][50], temp[50];<br />
           <code className='library'> printf</code>("Enter 5 words: ");<br />
           <br />
           <code className='comment'> // Getting strings input</code><br />
           <code className='library'> for</code> (int i = 0; i &lt; 5; ++i) &#123;<br />
           <code className='keywords'>    fgets</code>(str[i], sizeof(str[i]), stdin);<br />
   &#125;<br />
   <br />
   <code className='comment'>  // storing strings in the lexicographical order</code><br />
   <code className='library'> for</code> (int i = 0; i &lt; 5; ++i) &#123;<br />
   <code className='keywords'>   for</code> (int j = i + 1; j &lt; 5; ++j) &#123;<br />
   <br />
   <code className='comment'>   // swapping strings if they are not in the lexicographical order</code><br />
   <code className='library'>   if </code>(strcmp(str[i], str[j]) &gt; 0) &#123;<br />
            strcpy(temp, str[i]);<br />
            strcpy(str[i], str[j]);<br />
            strcpy(str[j], temp);<br />
         &#125;<br />
      &#125;<br />
   &#125;<br />
   <br />
   <code className='library'>  printf</code>("\nIn the lexicographical order: \n");<br />
   <code className='library'>   for</code> (int i = 0; i &lt; 5; ++i) &#123;<br />
   <code className='keywords'>    fputs</code>(str[i], stdout);<br />
   &#125;<br />
   <code className='library'>  return</code> 0;<br />
&#125;<br />
            </div>
        </div>
    )
}

export default Sixty_four
